export default __webpack_public_path__ + "static/media/RelateIcon.ad5eff04.png";